<template>
    <header>
      <div class="layer-container layer-container-header nav gap lg:a-w-1200 mb-0 zzl-ooo">
        <svg class="hidden-desktop mobile-arrow-left" viewBox="0 0 1024 1024" @click.prevent="go">
          <path d="M641.28 278.613333l-45.226667-45.226666-278.634666 278.762666 278.613333 278.485334 45.248-45.269334-233.365333-233.237333z"></path>
        </svg>
        <logo class="mt-12 lg:j-mt-0" @click.prevent="goShopping" />

        <ul class="options">
          <li class="item">
            <language position="header" />
          </li>
          <li class="item">
            <a-dropdown>
              <span class="link cursor-pointer">
                <svg viewBox="0 0 48 48">
                  <path
                    d="M24.4543885,3.32555736 C28.8145023,3.32555736 32.3623475,6.89854368 32.3623475,11.2905913 C32.3623475,15.6826389 28.8145023,19.2560904 24.4543885,19.2560904 C20.093813,19.2560904 16.5459678,15.6826389 16.5459678,11.2905913 C16.5459678,6.89854368 20.093813,3.32555736 24.4543885,3.32555736 M24.4543885,21.5816477 C30.0880877,21.5816477 34.6712406,16.9649513 34.6712406,11.2905913 C34.6712406,5.61623136 30.0880877,1 24.4543885,1 C18.8206893,1 14.2370747,5.61623136 14.2370747,11.2905913 C14.2370747,16.9649513 18.8206893,21.5816477 24.4543885,21.5816477 M42.5888969,34.0261703 C42.5856644,34.1717502 42.5828937,34.3136092 42.5810466,34.4489566 L42.5731964,34.4494217 L42.5741199,34.5540718 C42.5741199,34.5731414 42.5741199,34.5917458 42.5745817,34.6103503 C42.5731964,34.6470941 42.5727346,34.6847681 42.5727346,34.7238375 L42.5722728,35.8708024 C42.5713493,39.1368151 42.5708875,39.1982098 42.5630372,40.3651745 L42.5588812,41.8721357 C42.559343,41.9163213 42.5505692,41.9642278 42.5330216,42.0084133 C42.5094709,42.0725987 42.469758,42.140505 42.4314303,42.1898068 C41.9673428,42.7618939 40.5681536,43.6628149 40.1280786,43.6735124 L37.7296004,43.6744426 L36.718767,43.6735124 C36.4689448,43.5730483 35.8880273,43.321423 35.0023359,42.9200318 C34.6356836,42.7493359 34.2283949,42.6549183 33.750454,42.6386394 C27.9985395,42.6423603 20.9116229,42.6418952 15.1066039,42.6395696 C14.6762262,42.6549183 14.2730935,42.7493359 13.9124444,42.9172412 C13.5277828,43.0930533 12.5603565,43.5251419 12.1900101,43.6739775 C11.4548585,43.6744426 10.7183216,43.6744426 9.9799376,43.6739775 L8.78162207,43.6735124 C8.34108526,43.6628149 6.94466671,42.7656148 6.49720322,42.2158531 C6.44086623,42.1428306 6.39930615,42.0725987 6.37714078,42.0135296 C6.35820786,41.9642278 6.34943406,41.9172515 6.34989584,41.8605079 L6.34573983,40.3070356 C6.3378896,39.2042563 6.33742782,39.1010015 6.33696604,35.9038253 L6.33650426,34.7433722 C6.33650426,34.7033726 6.33604248,34.6643032 6.33465715,34.6266292 C6.33511893,34.6075596 6.33511893,34.5875598 6.33511893,34.5680251 L6.33604248,34.4666308 L6.32819225,34.4661657 C6.32634513,34.3275625 6.3226509,34.1782617 6.31941845,34.0140774 C6.31018288,33.5968724 6.30094731,33.1647838 6.3184949,32.7810669 C6.43024532,30.286674 7.33625498,28.5639011 9.25586872,27.1950781 C10.3682934,26.4015979 11.5984717,26.0081136 13.0032022,25.9918347 L35.8894126,25.9918347 C37.3089201,26.0081136 38.5400219,26.402063 39.6529084,27.1955432 C41.5729839,28.5648314 42.4789935,30.2871392 42.5902822,32.7806018 C42.6078298,33.1671094 42.5981324,33.6015235 42.5888969,34.0261703 M44.8968664,32.6764168 C44.7541768,29.4857521 43.47505,27.0718235 40.9874486,25.2978884 C39.4788178,24.2216204 37.8196472,23.6881376 35.9023424,23.6662774 L12.9902724,23.6662774 C11.0877445,23.6881376 9.42995926,24.2216204 7.92179028,25.2974233 C5.43418883,27.0713584 4.15506205,29.485287 4.01191067,32.6759517 C3.99159241,33.1368771 4.00128976,33.6085002 4.01144889,34.0922161 C4.0156049,34.2819816 4.01976091,34.4661657 4.02114625,34.6350012 C4.02160802,34.6773263 4.02253158,34.7187213 4.02484047,34.7587208 L4.02484047,34.809418 L4.02761115,34.809418 C4.02807292,35.0322064 4.02807292,35.3801098 4.02807292,35.9038253 C4.0285347,39.1130944 4.02945826,39.2168143 4.03684672,40.3233145 L4.04100273,41.8465546 C4.03684672,42.1805046 4.09595438,42.5125942 4.21924927,42.8409629 C4.32592014,43.1218902 4.48107775,43.3939804 4.69534304,43.6688613 C5.23377691,44.3321103 7.24020503,45.9990698 8.78023674,45.9990698 L9.97809048,45.9995349 C10.33366,46 10.6887678,46 11.0452609,46 C11.4918008,46 11.9397261,46 12.3913456,45.9990698 C12.588525,45.9967442 12.8111023,45.9944187 14.8761763,45.0307077 C14.9606818,44.9911732 15.0696616,44.9679176 15.1481639,44.9641968 C20.9097758,44.9669874 27.9980777,44.9679176 33.7102793,44.9632665 C33.8377302,44.9679176 33.9462481,44.9907081 34.0644635,45.0451261 C36.1637091,45.9962791 36.2528324,45.9990698 36.52482,45.9990698 L36.5271289,45.9990698 L37.7296004,46 L40.1285403,45.9990698 C41.6690338,45.9990698 43.6786944,44.3274591 44.2351376,43.6418848 C44.4318553,43.387934 44.5851658,43.1172391 44.6927603,42.8316607 C44.8114374,42.5144546 44.8700833,42.1860859 44.8677744,41.8637637 L44.8719304,40.3819185 C44.8797806,39.211233 44.8802424,39.148908 44.8811659,35.8712675 C44.8811659,35.3670866 44.8811659,35.0280204 44.8816277,34.8066273 L44.8848602,34.8066273 L44.8843984,34.7563953 C44.8867073,34.7168608 44.8876308,34.675931 44.8880926,34.6336059 C44.8890162,34.4596542 44.8931722,34.2726794 44.89779,34.0722163 C44.9070255,33.6140815 44.9171847,33.1396678 44.8968664,32.6764168">
                  </path>
                </svg>
                <span class="ellipsis link-span">{{ userInfo.nickName || '' }}</span>
                <DownOutlined :class="userInfo.nickName ? '' : '!ml-0'"/>
              </span>
              <template #overlay>
                <a-menu>
                  <template v-if="!!!userInfo.uid">
                    <a-menu-item @click.prevent="popLogin">{{ t('login.quickLogin') }}</a-menu-item>
                    <a-menu-item @click.prevent="acrossDomainJump('login')">{{ t('login.sign') }}</a-menu-item>
                    <a-menu-item @click.prevent="acrossDomainJump('register')">{{ t('member_index.common.register') }}</a-menu-item>
                    <a-menu-item v-if="isShowStory()" @click.prevent="gotoStory">{{ t('header.story') }}</a-menu-item>
                  </template>
                  <template v-else>
                    <a-menu-item @click.prevent="overview">{{ t('header.myJackery') }}</a-menu-item>
                    <a-menu-item @click.prevent="logout">{{ t('header.logout') }}</a-menu-item>
                    <a-menu-item v-if="isShowStory()" @click.prevent="gotoStory">{{ t('header.story') }}</a-menu-item>
                  </template>
                </a-menu>
              </template>
            </a-dropdown>
          </li>
          <li class="item" v-if="activityInfo.life?.isSHow">
            <button class="link" @click.prevent="goJackeryLife(activityInfo.life?.url)">
              <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>My Jackery life备份 4</title>
                <g id="会员系统2023" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.699999988">
                    <g id="用户中心2-我的订单1" transform="translate(-894.000000, -22.000000)">
                        <g id="My-Jackery-life备份-4" transform="translate(894.000000, 22.000000)">
                            <g id="编组" transform="translate(0.000000, 3.000000)" fill="#666666" fill-rule="nonzero">
                                <path d="M1.96514011,7.00000281 L2.05688041,7.00870163 C2.33415622,7.06056876 2.51736681,7.32999155 2.46609272,7.61047429 L1.03889442,15.4175703 C0.936259746,15.9987274 1.27960326,16.5495364 1.78251242,16.6545225 L17.5602689,19.9489851 C18.051736,20.0518183 18.5396831,19.6922197 18.6401233,19.1246568 L18.9861488,17.0855235 C19.0338539,16.8043972 19.2978187,16.615619 19.5757308,16.6638758 C19.8536429,16.7121326 20.0402626,16.9791504 19.9925576,17.2602768 L19.6459046,19.3030305 C19.4463002,20.4310937 18.4239752,21.1845086 17.3536374,20.9605542 L1.57610832,17.666139 C0.516308917,17.444898 -0.163759526,16.3538978 0.034235274,15.2328291 L1.46198818,7.42264682 C1.50756515,7.17332883 1.72307258,6.99919359 1.96514011,7.00000281 Z M21.0455594,0 C22.1333895,0 23,0.903172858 23,2.00006177 L23,13.9996364 C23,15.0967664 22.1334513,16 21.0455594,16 L4.95415104,16 C3.86628029,16 3,15.0967958 3,13.9996364 L3,2.00006177 C3,0.903143458 3.8663421,0 4.95415104,0 L21.0455594,0 Z M16.5091641,6.09358371 L12.0274145,11.9925269 L11.6728648,12.4591903 L11.2810707,12.0252976 L9.49421466,10.0464426 C9.41577375,9.95966195 9.30450618,9.95934951 9.22585934,10.0454723 L4.8489508,14.840635 C4.7990266,14.8953299 4.74008186,14.9360405 4.67673518,14.9626207 C4.76412931,14.9918573 4.85768006,15.0079952 4.95415104,15.0079952 L21.0455594,15.0079952 C21.5514891,15.0079952 21.9772416,14.5642186 21.9772416,13.9996364 L21.977,12.537 L16.8005558,6.08830441 C16.7177289,5.98503304 16.590189,5.98692572 16.5091641,6.09358371 Z M21.0455594,0.992004794 L4.95415104,0.992004794 C4.44833841,0.992004794 4.02275838,1.43566305 4.02275838,2.00006177 L4.02275838,13.9996364 C4.02275838,14.0914042 4.03399789,14.1799768 4.05499492,14.263969 C4.07468591,14.2214818 4.1010827,14.1825737 4.13338029,14.1471898 L8.51036568,9.35194295 C8.97837706,8.83944332 9.74755248,8.8416032 10.2132287,9.35678943 L11.6078995,10.9014674 L15.735645,5.46968251 C16.2030173,4.8544516 17.0749437,4.84151232 17.5576559,5.44337483 L21.977,10.949 L21.9772416,2.00006177 C21.9772416,1.43574876 21.5514614,0.992004794 21.0455594,0.992004794 Z M7.99984555,3 C9.11364709,3 10,3.90356605 10,5 C10,6.09643395 9.11364709,7 7.99984555,7 C6.88628589,7 6,6.09636972 6,5 C6,3.90363028 6.88628589,3 7.99984555,3 Z M7.99984555,4.03476214 C7.50726735,4.03476214 7.09113278,4.45904035 7.09113278,5 C7.09113278,5.54095965 7.50726735,5.96523786 7.99984555,5.96523786 C8.49270412,5.96523786 8.90886722,5.54099281 8.90886722,5 C8.90886722,4.45900719 8.49270412,4.03476214 7.99984555,4.03476214 Z" id="形状结合"></path>
                            </g>
                            <rect id="矩形备份-13" x="0.0235900595" y="0" width="23.9764099" height="24"></rect>
                        </g>
                    </g>
                </g>
              </svg>
              <Badge :count="activityInfo.life?.msgCount">
                <span class="link-span">{{ t('jackeryStories.title') }}</span>
              </Badge>
            </button>
          </li>
        </ul>
      </div>
  </header>
</template>
<script setup>
  import { DownOutlined } from "@ant-design/icons-vue";
  import Logo from "@c/Logo.vue";
  import { message, Modal, Badge } from 'ant-design-vue';
  import { useStore } from 'vuex';
  import { cookie, uLogin, } from '@u/common'
  import { shopifyLogin } from "@a/userCommon";
  import { jackeryLifeInfo } from "@a/activity";
  import Language from "@c/Language.vue";
  import { go } from "@u/helpers/utils"

  const { t } = useI18n();
  const store = useStore();
  const router = useRouter();

  const props = defineProps({
    from: {
      type: String,
      default: 'account',
      required: false
    }
  })

  const userInfo = computed(() => store.getters.userInfo);
  const language_current = computed(() => store.getters.language.current);
  const cr = language_current.value.cr;
  const isShowStory = () => ['GB','US','DE'].includes(cr)
  // 跨域名 跳转
  const acrossDomainJump = route => {
      window.location.href = `${import.meta.env.VITE_ID_URL}/${route}?redirect=/index`
  }

  const popLogin = () => {
    if(window.jackeryLoginApp) {
      window.jackeryLoginApp.modalLogin({
        "register_act": "Account-Register"
      })
    }
    return
  }

  const logout = () => {
    Modal.confirm({
      title: t('tips.logoutConfirm'),
      okText: t('operate.confirm'),
      cancelText: t('operate.cancel'),
      onOk: () => {
        store.dispatch('app/logout').then(res => {
          //会员主页不跳转C端首页
          if(window.location.pathname.indexOf("/index") !== -1 ){
            res && router.push({ path: '/login' , query: {redirect_url: location.href}})
          }else{
            //个人中心页跳转C端首页
            window.location.href = language_current.value.domain
          }
          message.success(t('tips.loggedOut'));
        }).catch(e => {
          console.log(e)
        })
      }
    })
  }

  const goShopping = () => {
    if (props.from == 'membership' && !userInfo.value.uid) {
      window.location.href = language_current.value.domain
    } else {
      uLogin(shopifyLogin, language_current.value.shop_id, language_current.value.domain);
    }
  }

  const goJackeryLife = (url) => {
    uLogin(shopifyLogin, language_current.value.shop_id, url);
  }

  /** =============== 活动信息, 地球日, life, start =============== */
  const activityInfo = reactive({
    earthDay: {}, life: {}
  });

  const getActivity = () => {
    if (!userInfo.value.email && !userInfo.value.uid) { return }
    jackeryLifeInfo({ uid: userInfo.value.uid, shopId: language_current.value.shop_id }).then(r => {
      activityInfo.life = r
    })
  }
  /** =============== 活动信息, 地球日, life, end =============== */

  const overview = () => {
      if (router.currentRoute.value.name === 'accountOverview') return
      message.loading(t('tips.loading'), 5);
      uLogin(shopifyLogin, language_current.value.shop_id, `${location.origin.replace('membership', 'account')}/account/overview`)
  };

  const gotoWishlist = () => {
      if (router.currentRoute.value.name === 'accountWishlist') return
      message.loading(t('tips.loading'), 5);
      uLogin(shopifyLogin, language_current.value.shop_id, `${location.origin.replace('membership', 'account')}/account/wishlist`)
  };

  const gotoStory = () => {
    message.loading(t('tips.loading'), 5);
    uLogin(shopifyLogin, language_current.value.shop_id, `https://${language_current.value.domain}/pages/join-jackery-stories`, true)
  };

  watch(() => userInfo.value.uid, (newValue, oldValue) => {
    getActivity()
  })

  onMounted(() => {
    // getActivity()
  })

</script>

<style scoped lang="less">
  header {
    width: 100vw;
    background: var(--normal-color);
    display: flex;
    justify-content: center;
    position: fixed;
    top: 0;
    z-index: 9;

    .nav {
      height: var(--nav);
      display: flex;
      align-items: center;

      .logo {
        margin-right: 25px;
      }

      h2 {
        font-size: var(--font-normal);
        font-weight: 600;
        color: var(--regular-color);
      }

      .options {
        height: inherit;
        display: flex;
        align-items: center;
        flex-grow: 1;
        flex-direction: row-reverse;
      }

      .item {
        margin-right: 48px;
        color: var(--regular-color);

        &:first-child {
          margin-right: 0;
        }

        .link {
          background-color: transparent;
          color: var(--regular-color);
          display: flex;
          align-items: center;

          span.ellipsis {
            max-width: 120px;
          }

          ::v-deep(.ant-badge-count) {
            background: #ff7429;
            right: -10px;
            min-width: 15px;
            height: 15px;
            padding: 0 3px;
            line-height: 15px
          }
        }

        svg {
          width: 24px;
          height: 24px;
          display: inline-block;
          margin-right: 10px;
          fill: currentColor;
        }

        .anticon {
          margin-left: 8px;
          color: var(--weak-color);
        }

        .language {
          position: static;
        }
      }
    }
  }

  @media (max-width: 540px) {
    header {
      .mobile-arrow-left {
        position: relative;
        left: -10px;
        top: initial;
      }

      .nav {
        .item {
          margin-right: var(--gap);
          color: var(--main-text-color);
        }

        .link {
          svg {
            margin-right: 0;
          }

          .link-span {
            display: none;
          }

          ::v-deep(.ant-badge-count) {
            background: #ff7429;
            right: -4px !important;
            top: -10px;
            min-width: 15px;
            height: 15px;
            padding: 0 3px;
            line-height: 15px;
          }
        }
      }
    }
  }
</style>
